module.exports = __webpack_public_path__ + "img/applyStep.fca46b19.png";